// middleware
import * as amdShareLinkMiddleware from '@makemydeal/dr-dash-store/middleware/amdShareLinkMiddleware';
import * as accessoriesMiddleware from '@makemydeal/dr-dash-store/middleware/accessoriesMiddleware';
import * as aiMiddleware from '@makemydeal/dr-dash-store/middleware/aiMiddleware';
import * as altDealStructureMiddleware from '@makemydeal/dr-dash-store/middleware/altDealStructureMiddleware';
import * as analyticsMiddleware from '@makemydeal/dr-dash-store/middleware/analyticsMiddleware';
import * as avoMiddleware from '@makemydeal/dr-dash-store/middleware/avoMiddleware';
import * as changeVehicleMiddleware from '@makemydeal/dr-dash-store/middleware/changeVehicleMiddleware';
import * as consumerInsightsMiddleware from '@makemydeal/dr-dash-store/middleware/consumerInsightsMiddleware';
import * as openRepairOrdersMiddleware from '@makemydeal/dr-dash-store/middleware/openRepairOrdersMiddleware';
import * as contractingMiddleware from '@makemydeal/dr-dash-store/middleware/contractingMiddleware';
import * as dealHistoryMiddleware from '@makemydeal/dr-dash-store/middleware/dealHistoryMiddleware';
import * as pendingDealerReviewMiddleware from '@makemydeal/dr-dash-store/middleware/pendingDealerReviewMiddleware';
import { dealRefIdMiddleware } from '@makemydeal/dr-dash-store/middleware/dealRefIdMiddleware';
import { commonConsumerIdMiddleware } from '@makemydeal/dr-dash-store/middleware/commonConsumerIdMiddleware';
import * as dealSpdMiddleware from '@makemydeal/dr-dash-store/middleware/dealSpdMiddleware';
import * as dealershipSelectionMiddleware from '@makemydeal/dr-dash-store/middleware/dealershipSelectionMiddleware';
import * as docUploadMiddleware from '@makemydeal/dr-dash-store/middleware/docUploadMiddleware';
import * as dpmMiddleware from '@makemydeal/dr-dash-store/middleware/dpmMiddleware';
import * as employeeDetailsMiddleware from '@makemydeal/dr-dash-store/middleware/employeeDetailsMiddleware';
import * as lenderAddressMiddleware from '@makemydeal/dr-dash-store/middleware/lenderAddressMiddleware';
import * as notificationMiddleware from '@makemydeal/dr-dash-store/middleware/notifyMiddleware';
import * as paymentGridMiddleware from '@makemydeal/dr-dash-store/middleware/paymentGridMiddleware';
import * as paymentMiddleware from '@makemydeal/dr-dash-store/middleware/paymentMiddleware';
import * as quoteModeInitialPaymentMiddleware from '@makemydeal/dr-dash-store/middleware/quoteModeInitialPaymentMiddleware';
import * as fsSyncFailureMiddleware from '@makemydeal/dr-dash-store/middleware/fsSyncFailureMiddleware';
import * as printPdfMiddleware from '@makemydeal/dr-dash-store/middleware/printPdfMiddleware';
import * as pushToDarwinMiddleware from '@makemydeal/dr-dash-store/middleware/pushToDarwinMiddleware';
import * as pushToDmsMiddleware from '@makemydeal/dr-dash-store/middleware/pushToDmsMiddleware';
import * as pushToFIMiddleware from '@makemydeal/dr-dash-store/middleware/pushToFIMiddleware';
import * as pushToRouteOneMiddleware from '@makemydeal/dr-dash-store/middleware/pushToRouteOneMiddleware';
import * as rateTypeMiddleware from '@makemydeal/dr-dash-store/middleware/rateTypeMiddleware';
import * as vAutoAppraisalTelemetryMiddleware from '@makemydeal/dr-dash-store/middleware/vAutoAppraisalTelemetryMiddleware';
import * as vAutoMiddleware from '@makemydeal/dr-dash-store/middleware/vAutoMiddleware';
import * as vAutoTriforceMiddleware from '@makemydeal/dr-dash-store/middleware/vAutoTriforceMiddleware';
import * as vehicleProtectionMiddleware from '@makemydeal/dr-dash-store/middleware/vehicleProtectionMiddleware';
import * as autoSelectStateMiddleware from '@makemydeal/dr-dash-store/middleware/autoSelectStateMiddleware';
import * as autoSelectedProgramMiddleware from '@makemydeal/dr-dash-store/middleware/autoSelectedProgramMiddleware';
import * as mvDealStateMiddleware from '@makemydeal/dr-dash-store/middleware/mvDealStateMiddleware';
import * as unsavedChangesMiddleware from '@makemydeal/dr-dash-store/middleware/unsavedChangesMiddleware';
import * as customerSpdMiddleware from '@makemydeal/dr-dash-store/middleware/customerSpdMiddleware';
import * as piiConsistencyMiddleware from '@makemydeal/dr-dash-store/middleware/piiConsistencyMiddleware';
import * as dealerDiscountsMiddleware from '@makemydeal/dr-dash-store/middleware/dealerDiscountsMiddleware';
import * as paymentFrequencyMiddleware from '@makemydeal/dr-dash-store/middleware/paymentFrequencyMiddleware';
import * as userImpersonationMiddleware from '@makemydeal/dr-dash-store/middleware/roleAssumptionMiddleware';
import * as taxesMiddleware from '@makemydeal/dr-dash-store/middleware/taxesMiddleware';
import * as profitMiddleware from '@makemydeal/dr-dash-store/middleware/profitMiddleware';
import * as vehicleMiddleware from '@makemydeal/dr-dash-store/middleware/vehicleMiddleware';
import * as globalPrintingSettingsMiddleware from '@makemydeal/dr-dash-store/middleware/globalPrintingSettingsMiddleware';

import { navigationMiddleware } from '../middleware/navigationMiddleware';
import { postBootstrapMiddleware } from '../middleware/postBootstrapMiddleware';
import { toggleStatsMiddleware } from '../middleware/toggleStatsMiddleware';

// config
import { tradeConfiguration } from '../activities/trade';
import { programsWithEndpointMiddleware } from './programsMiddleware';
import { changeVehicleConfiguration } from '../activities/change-vehicle';
import { fuelSavingConfiguration } from '../activities/fuel-saving';
import { openDealConfiguration } from '../activities/open-deal-dashboard';
import { dealershipPickerConfiguration } from '../activities/dealership-picker';
import { roleAssumptionConfiguration } from '../activities/role-assumption';
import { recentDealsConfiguration } from '../activities/recent-deals';
import { customerCardConfiguration, customerCardActivityMiddleware } from '../activities/customer-card';

// TODO: DASH - restore middleware needed
// import { dataIslandMiddlewareFactory } from '../common/dataIslandMiddlewareFactory';
// import { initOfferReduxMiddleware } from '../middleware/initOfferRedux';
// import { offerMiddleware } from '../middleware/offer/offer';

// // config
// TODO: DASH - restore config imports if needed
// import config /* , { isP202RedesignEnabled, isDocUploadEnabled, isFinishMyDealEnabled, isAccessoriesEnabled } */ from '../../../config';

// TODO: DASH - restore if needed
// import { DataIslandModel } from './../common/dataIslandMiddlewareFactory/dataIslandModel';

// TODO: DASH - restore if needed
// const dataIslandMiddleware = dataIslandMiddlewareFactory(
//     config.analytics.dataIslandKey,
//     config.analytics.propertyToTrack,
//     (action, state) => new DataIslandModel(action, state)
// );

// Use both manager view specific middleware and the internal one from the activity-change-vehicle
const changeVehicleMiddlewares = [changeVehicleConfiguration.middleware, changeVehicleMiddleware.middleware];

export const getRemainingMiddleware = () => {
    return [
        amdShareLinkMiddleware.middleware,
        postBootstrapMiddleware,
        // TODO: DASH - restore if needed
        // dataIslandMiddleware,
        navigationMiddleware,
        // TODO: DASH - restore if needed
        // initOfferReduxMiddleware as any,
        accessoriesMiddleware.middleware,
        aiMiddleware.middleware,
        altDealStructureMiddleware.middleware,
        avoMiddleware.middleware,
        toggleStatsMiddleware,
        analyticsMiddleware.middleware,
        dealHistoryMiddleware.middleware,
        pendingDealerReviewMiddleware.middleware,
        dpmMiddleware.middleware,
        ...changeVehicleMiddlewares,
        paymentGridMiddleware.middleware,
        paymentMiddleware.getMiddleware(),
        quoteModeInitialPaymentMiddleware.middleware,
        tradeConfiguration.middleware,
        notificationMiddleware.middleware,
        docUploadMiddleware.middleware,
        pushToDmsMiddleware.middleware,
        pushToDarwinMiddleware.middleware,
        pushToFIMiddleware.middleware,
        fsSyncFailureMiddleware.middleware,
        pushToRouteOneMiddleware.middleware,
        vehicleProtectionMiddleware.middleware,
        programsWithEndpointMiddleware,
        consumerInsightsMiddleware.middleware,
        openRepairOrdersMiddleware.middleware,
        // Must stay directly above vAutoMiddleware: it measures whether the ACV write actually landed by
        // reading the trade either side of next(), which only works while vAutoMiddleware is downstream.
        vAutoAppraisalTelemetryMiddleware.middleware,
        vAutoMiddleware.middleware,
        vAutoTriforceMiddleware.middleware,
        printPdfMiddleware.middleware,
        dealRefIdMiddleware,
        commonConsumerIdMiddleware,
        contractingMiddleware.middleware,
        employeeDetailsMiddleware.middleware,
        lenderAddressMiddleware.middleware,
        rateTypeMiddleware.middleware,
        dealSpdMiddleware.middleware,
        piiConsistencyMiddleware.middleware,
        mvDealStateMiddleware.middleware,
        autoSelectStateMiddleware.middleware,
        autoSelectedProgramMiddleware.middleware,
        unsavedChangesMiddleware.middleware,
        customerSpdMiddleware.middleware,
        openDealConfiguration.middleware,
        dealershipPickerConfiguration.middleware,
        dealershipSelectionMiddleware.middleware,
        dealerDiscountsMiddleware.middleware,
        paymentFrequencyMiddleware.middleware,
        roleAssumptionConfiguration.middleware,
        recentDealsConfiguration.middleware,
        customerCardConfiguration.middleware,
        customerCardActivityMiddleware,
        fuelSavingConfiguration.middleware,
        userImpersonationMiddleware.middleware,
        taxesMiddleware.middleware,
        profitMiddleware.middleware,
        vehicleMiddleware.middleware,
        globalPrintingSettingsMiddleware.middleware
    ];
};
